module.exports = __webpack_public_path__ + "static/img/10.a1dc53b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/10.png
// module id = r9SO
// module chunks = 0